import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { StackLayout, SectionGrid, getValuesOfEnum } from '@wemogy/reactbase';
import useAuthorizationStore from '../../../hooks/UseAuthorizationStore';
import PermissionListItem from '../../permission/permissionListItem/PermissionListItem';
var RolePermissions = function (_a) {
    var role = _a.role, onPermissionPressed = _a.onPermissionPressed;
    var authorizationStore = useAuthorizationStore();
    var permissionLevelKeys = useMemo(function () { return Object.keys(authorizationStore.config.permissionLevels); }, [authorizationStore.config.permissionLevels]);
    var sections = permissionLevelKeys.map(function (permissionLevelKey) {
        var permissionLevel = authorizationStore.config.permissionLevels[permissionLevelKey];
        // all enum values without the zero value
        var permissionLevelEnums = getValuesOfEnum(permissionLevel.permissionEnum).filter(function (x) { return x > 0; });
        console.log(permissionLevelKey, permissionLevel.permissionEnum, permissionLevelEnums);
        // remove hidden permissions if given
        var staticPermissions = permissionLevel.staticPermissions;
        if (staticPermissions) {
            permissionLevelEnums = permissionLevelEnums.filter(function (x) { return !staticPermissions.find(function (staticPermission) { return staticPermission.permissionFlag === x && staticPermission.hidden; }); });
        }
        return ({
            icon: permissionLevel.icon,
            rowHeight: 6,
            title: permissionLevel.translationPrefix + "roleName",
            itemRenderer: function (itemIndex) {
                var permissionEnumValue = permissionLevelEnums[itemIndex];
                return (React.createElement(PermissionListItem, { role: role, permissionLevel: permissionLevel, permissionEnumValue: permissionEnumValue, onPress: onPermissionPressed }));
            },
            itemsCount: permissionLevelEnums.length
        });
    });
    return (React.createElement(StackLayout, { minHeight: { custom: '50vh' } },
        React.createElement(SectionGrid, { columnCount: 3, emptyRenderer: function () { return null; }, sections: sections })));
};
export default observer(RolePermissions);
//# sourceMappingURL=RolePermissions.js.map